import dayjs from "lib/dayjs"

import { ApiTypes } from "types"

export interface MonthlyPlacements {
  labels: string[]
  values: number[]
  inProgress: boolean[]
  inProgressLabel?: string
}

const toMonthLabel = (month: string) => dayjs(`${month}-01`).format("MMM")

export const buildMonthlyPlacements = ({
  months,
}: ApiTypes.Model.ReferralAgentDashboardMonthlyPlacements): MonthlyPlacements => {
  const inProgressBucket = months.find(({ in_progress }) => in_progress)

  return {
    labels: months.map(({ month }) => toMonthLabel(month)),
    values: months.map(({ value }) => value),
    inProgress: months.map(({ in_progress }) => in_progress),
    inProgressLabel: inProgressBucket && toMonthLabel(inProgressBucket.month),
  }
}
